var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeverOperationTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 346,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "leverOperationTimeIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 370",
    fill: "none",
    d: "M0 0h199v199H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "leverOperationTimeIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 492",
    transform: "translate(0 .647)",
    fill: "none",
    d: "M0 0h200v200H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 502"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(147 1)",
    clipPath: "url(#leverOperationTimeIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 368",
    fill: "#060404"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 498",
    d: "M157.541 181.86H41.458v-4.975a3.317 3.317 0 013.317-3.316h109.45a3.317 3.317 0 013.317 3.317z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 499",
    d: "M143.864 174.217H55.139v-14.925a9.95 9.95 0 019.95-9.95h68.821a9.95 9.95 0 019.95 9.95z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.647)",
    clipPath: "url(#leverOperationTimeIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 490",
    d: "M95.367 161.08l19.72-34.182 1.738 1.003-19.72 34.182z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 491",
    d: "M108.886 161.144l16.21-28.099 1.738 1.003-16.21 28.099z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 496"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 858",
    d: "M154.504 123.841a26.252 26.252 0 112.675-19.967 26.308 26.308 0 01-2.675 19.967"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 859",
    d: "M158.852 183.369H41.803v-16.721a6.689 6.689 0 016.689-6.689h103.671a6.689 6.689 0 016.688 6.689z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 497"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 860",
    d: "M182.596 78.804l-7.8 3.679a63.095 63.095 0 00-113.649 0l-7.751-3.512a1.393 1.393 0 00-1.951 1.449l2.341 23.633a1.393 1.393 0 002.174 1l19.341-13.875a1.393 1.393 0 000-2.4l-7.525-3.4a56.183 56.183 0 01101 0l-7.692 3.79a1.393 1.393 0 000 2.4l19.452 13.6a1.393 1.393 0 002.174-1l2.062-23.688a1.393 1.393 0 00-1.951-1.393"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverOperationTimeIcon);
export default __webpack_public_path__ + "static/media/leverOperationTimeIcon.9a1cabe2838c8046.svg";
export { ForwardRef as ReactComponent };